import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { FileText, Zap, Users, ShieldCheck, CreditCard, Star, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 overflow-hidden" data-id="element-140">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-142">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-[#1E2A4A] leading-tight mb-5 md:mb-7 max-w-2xl mx-auto" data-id="element-143">
            Todo tu año de tareas, crisis y rutinas con TDAH, resuelto
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="relative mb-2" data-id="element-144">
            <div className="absolute inset-0 bg-[#8A9A86]/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-145"></div>
            <img src="https://cdn.magicpatterns.com/uploads/46dxcNDzrEJSBTsmWPfic4/MOCKUP_MEGAPACK_TDAH_EN_CALMA.png" alt="Mockup del MEGAPACK TDAH EN CALMA: pila de libros con tarjetas de bonos y laptop" width={448} height={448} loading="eager" fetchPriority="high" decoding="async" className="w-[70%] max-w-sm mx-auto h-auto drop-shadow-2xl" data-id="element-146" />
          </motion.div>

          <p className="md:text-xs font-semibold tracking-wide uppercase text-[#1E2A4A]/50 mb-5 md:mb-6 text-[9px]" data-id="element-147">
            MEGAPACK TDAH EN CALMA · 8 Tomos + 6 Bonos
          </p>

          <p className="text-base md:text-xl text-[#1E2A4A]/80 mb-6 md:mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-148">
            Tu plan completo para acompañar a tu hijo con TDAH listo: tareas sin
            batalla, crisis manejables, concentración real, colegio y obra
            social resueltos. Sin agotarte más.
          </p>

          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8" data-id="element-149">
            <div className="flex items-center gap-1.5 md:gap-2 bg-white px-2.5 py-1.5 md:px-3 md:py-2 rounded-lg shadow-sm text-xs md:text-sm font-medium text-[#1E2A4A]" data-id="element-150">
              <FileText size={16} className="text-[#E76F51]" data-id="element-151" />
              📄 PDF Digital
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 bg-white px-2.5 py-1.5 md:px-3 md:py-2 rounded-lg shadow-sm text-xs md:text-sm font-medium text-[#1E2A4A]" data-id="element-152">
              <Zap size={16} className="text-[#E76F51]" data-id="element-153" />⚡ Inmediato
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 bg-white px-2.5 py-1.5 md:px-3 md:py-2 rounded-lg shadow-sm text-xs md:text-sm font-medium text-[#1E2A4A]" data-id="element-154">
              <Users size={16} className="text-[#E76F51]" data-id="element-155" />
              👩‍👧 Mamás y Papás
            </div>
          </div>

          <Button scrollToId="precios" className="w-full sm:w-auto mb-4 md:mb-6 py-3 md:py-4 text-base md:text-lg" data-id="element-156">
            💥 QUIERO MI TDAH EN CALMA AHORA
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1.5 text-xs md:text-sm text-[#1E2A4A]/70 font-medium" data-id="element-157">
            <span className="flex items-center gap-1" data-id="element-158">
              <ShieldCheck size={14} data-id="element-159" /> Garantía 7 días
            </span>
            <span className="hidden sm:inline" data-id="element-160">•</span>
            <span className="flex items-center gap-1" data-id="element-161">
              <CreditCard size={14} data-id="element-162" /> Pago seguro
            </span>
            <span className="hidden sm:inline" data-id="element-163">•</span>
            <span className="flex items-center gap-1" data-id="element-164">
              <Star size={14} className="fill-yellow-400 text-yellow-400" data-id="element-165" /> 4.9
              Rating
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}